import { http } from "../../../shared/api/http";
import { ChatPreview } from "../models/type";

export async function chatDialogs(): Promise<ChatPreview[]> {
  const res = await http.get(`/restaurant/chat/dialogs`);
  return res.data;
}